export class HyperLink {
    public static VIETTEL_TELECOM = 'https://vietteltelecom.vn/';
    public static PHONE_NUMBER = '1800 8009 ';
    public static DOMAIN_VIETTEL_VCONTRACT = `${window.location.protocol}//${window.location.host}/about`;
}
